import type { Runtime } from '@/core/enums/runtime.enum'
import type { ClassData, MethodData } from '@/core/types/library.type'

import type { UseMemberExecutionResult } from './types'
import { useMemberExecution } from './useMemberExecution'

export interface UseMethodExecutionParams {
  method: MethodData
  methodKey: string
  classData: ClassData
  runtimeName: Runtime
}

export function useMethodExecution({
  method,
  methodKey,
  classData,
  runtimeName,
}: UseMethodExecutionParams): UseMemberExecutionResult {
  return useMemberExecution({ member: { kind: 'method', method, methodKey }, classData, runtimeName })
}
